import { render, staticRenderFns } from "./CreditRequestRegistrationForm.vue?vue&type=template&id=608a5855&scoped=true&"
import script from "./CreditRequestRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./CreditRequestRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./CreditRequestRegistrationForm.vue?vue&type=style&index=0&id=608a5855&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a5855",
  null
  
)

export default component.exports